// import { FlowsPage, FlowDetailsPage } from './views';

const FlowsPage = () => import(/* webpackChunkName: "flows" */ './views/FlowsPage/FlowsPage');
const FlowDetailsPage = () =>
    import(/* webpackChunkName: "flows" */ './views/FlowDetailsPage/FlowDetailsPage');

const routes = [
    {
        path: '/flows',
        name: 'flows',
        component: FlowsPage,
        meta: {
            title: 'Flows',
        },
    },
    {
        path: '/flows/:id',
        name: 'flows-id',
        component: FlowDetailsPage,
        props: true,
        meta: {
            title: 'Flow',
        },
    },
];

export default routes;
